import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles/tokens.css";
import "./styles/base.css";
import "./styles/layout.css";
import "./styles/components.css";
import { initFirebase } from "./firebase";

const root = createRoot(document.getElementById("root")!);

// Firebase config may come from Hosting at runtime (/__/firebase/init.json), so the app renders after it.
initFirebase()
  .then(async () => {
    const { App } = await import("./App");
    root.render(
      <StrictMode>
        <App />
      </StrictMode>,
    );
  })
  .catch((error: unknown) => {
    console.error(error);
    root.render(
      <div className="auth-page">
        <div className="auth-card">
          <h1>Painel indisponível</h1>
          <p className="text-2">Não foi possível carregar a configuração do Firebase. Tente de novo em instantes.</p>
        </div>
      </div>,
    );
  });
